var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CompanyService } from '~/services/management-service/company.service';
import { Emit } from 'vue-property-decorator';
var ModifyCompany = /** @class */ (function (_super) {
    __extends(ModifyCompany, _super);
    function ModifyCompany() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 公司数据实体
        _this.companyModel = {
            companyAddress: '',
            companyName: '',
            companyPhone: '',
            companyStatus: '',
            id: '',
        };
        _this.companyRules = {
            companyName: [
                { required: true, message: '请输入公司名称', trigger: 'blur' },
            ],
            companyAddress: [
                { required: true, message: '请输入公司地址', trigger: 'blur' },
            ],
            companyPhone: [
                { required: true, message: '请输入公司电话', trigger: 'blur' },
            ],
            companyStatus: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        };
        return _this;
    }
    ModifyCompany.prototype.refreshList = function () { };
    ModifyCompany.prototype.close = function () {
        this.reset();
    };
    /**
     * 重置form
     */
    ModifyCompany.prototype.reset = function () {
        var Form = this.$refs["form"];
        Form.resetFields();
    };
    /**
     * 反显数据
     */
    ModifyCompany.prototype.update = function (data) {
        if (!data.id)
            return;
        this.companyModel = __assign({}, data);
    };
    /**
     * 提交验证并并与数据库交互
     */
    ModifyCompany.prototype.commit = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (valid) {
            if (!valid) {
                return;
            }
            var result = _this.companyModel.id ? _this.updateCompany() : _this.addCompany();
            if (result) {
                _this.close();
                _this.companyModel = {};
            }
        });
    };
    /**
     * 新增公司
     */
    ModifyCompany.prototype.addCompany = function () {
        var _this = this;
        this.companyService.createCompany(this.companyModel).subscribe(function (data) {
            _this.$message.success('新增成功!');
            _this.refreshList();
        }, function (_a) {
            var msg = _a.msg;
            return false;
        });
        return true;
    };
    /**
     * 修改公司
     */
    ModifyCompany.prototype.updateCompany = function () {
        var _this = this;
        this.companyService.modify(this.companyModel).subscribe(function (data) {
            _this.$message.success('修改成功!');
            _this.refreshList();
        }, function (err) {
            return false;
        });
        return true;
    };
    __decorate([
        Dependencies(CompanyService)
    ], ModifyCompany.prototype, "companyService", void 0);
    __decorate([
        Emit('refreshList')
    ], ModifyCompany.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], ModifyCompany.prototype, "close", null);
    ModifyCompany = __decorate([
        Component({
            components: {},
        })
    ], ModifyCompany);
    return ModifyCompany;
}(Vue));
export default ModifyCompany;
